import axios from 'axios';
import { AUDIENCE_STUDIO_API_ENDPOINT } from './variables';
import { auth } from 'utils/firebase';
import { call, cancelled, put, takeLatest } from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';
import { fillUPCSearchResults, searchQuery } from './slice';

interface SearchProps {
  category: string;
  query: string;
}

let cancelPreviousRequest: (() => void) | null = null;

export function resetSearchRequestCancellationForTests() {
  cancelPreviousRequest = null;
}

export function handleSearch(params: SearchProps) {
  return auth.currentUser.getIdTokenResult().then(res => {
    if (cancelPreviousRequest) {
      cancelPreviousRequest();
    }
    const cancelSource = axios.CancelToken.source();
    cancelPreviousRequest = () => cancelSource.cancel('Cancelled stale search');
    const authorizedAxiosInstance = axios.create({
      headers: {
        Authorization: `Bearer ${res.token}`,
      },
    });
    return authorizedAxiosInstance.get(
      `${AUDIENCE_STUDIO_API_ENDPOINT}/products?category=${params.category}&query=${params.query}`,
      {
        cancelToken: cancelSource.token,
      }
    );
  });
}

export function* watchSearchQuery(action: PayloadAction<SearchProps>) {
  try {
    const result = yield call(handleSearch, action.payload);
    yield put(fillUPCSearchResults(result.data));
    return;
  } catch (e) {
    if (axios.isCancel(e)) {
      return;
    }
    console.log(e);
  } finally {
    if (yield cancelled()) {
      if (cancelPreviousRequest) {
        cancelPreviousRequest();
      }
    }
  }
}

export default function* watchAll() {
  yield takeLatest<any>(searchQuery.type, watchSearchQuery);
}
